import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";
//import createPersistedState from 'vuex-persistedstate'
//import * as Cookies from 'js-cookie'


//if (localStorage.getItem('access_token'))
//    axios.defaults.headers.common['Authorization'] = `Token ${localStorage.getItem('access_token')}`
//else
//    axios.defaults.headers.common['Authorization'] = null

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        test: "",
        route: '/',
        // user info from db
        userLoaded: false,
        userMember: false,
        userData: {
            timeInForce: null,
            platforms: {
                sierrachart: { apikey: null, accountname: null }
            },
            social: { avatar: null, birth: null, gender: null },
            username: "Visitor",
            token: localStorage.getItem('access_token') || null,
            settings: {
                submenus: {
                    Section0: {
                        selected: 0,
                        items: [
                            { name: "NQZ9-CME", component: "NQZ9-CME", activity: 2 },
                            { name: "RTYZ9-CME", component: "RTYZ9-CME", activity: 0 },
                            { name: "NQZ9-CME", component: "NQZ9-CME", activity: 2 },
                            { name: "NQZ9-CME", component: "NQZ9-CME", activity: 2 }
                        ]
                    },
                    Section1: {
                        selected: 0,
                        items: [
                            { name: "Timeline", component: "PoolTimeline", activity: 2 },
                            { name: "Trading Diary", component: "TradingDiary", activity: 0 },
                            { name: "Trade Preparation", component: "TradePreparation", activity: 2 }
                        ]
                    },
                    Section2: {
                        selected: 0,
                        items: [
                            { name: "Open Trades", component: "OpenTrades", activity: 0 },
                            { name: "Last Trades", component: "ClosedTrades", activity: 0 },
                            { name: "Daily Results", component: "DailyResults", activity: 0 }
                        ]
                    }
                }
            },
            //  set [] for deploy:
            minichartsTag: [
                { component: "MiniEquity", name: "Equity" },
                { component: "MiniGauge", name: "Success Rate" },
                { component: "MiniMarkets", name: "Markets" },
                { component: "MiniWeek", name: "Week Days" }
            ]
        },
        isConnected: false,
        socketMessage: "",
        apiServer: "https://tradeinpool.com:3001",
        componentMap: {
            TickerMonitor: {
                id: 0,
                name: "Ticker Monitor",
                component: "TickerMonitor",
                data: [
                    "NQZ9-CME"
                ],
            },
            Chart: {
                id: 1,
                name: "Charts",
                component: "Chart",
                activity: 2,
                data: [
                    { id: 0, name: "NQU9-CME", activity: 2, tick: 0.25, pointValue: 20, last: 7544, prev: 7544, open: 7521, change: 3.4, diff: 25 },
                    { id: 3, name: "RTYU9-CME", activity: 2, tick: 0.1, pointValue: 50, last: 2700, prev: 2700, open: 2790, change: -1.4, diff: -90 },
                    { id: 4, name: "MNQU9-CME", activity: 2, tick: 0.1, pointValue: 50, last: 2700, prev: 2700, open: 2790, change: -1.4, diff: -90 },
                    { id: 5, name: "M2kU9-CME", activity: 2, tick: 0.1, pointValue: 50, last: 2700, prev: 2700, open: 2790, change: -1.4, diff: -90 },
                ],
                settings: { markets: [0, 1, 2, 3] }
            },
            PoolTimeline: {
                id: 2,
                name: "Pool Timeline",
                component: "PoolTimeline",
                transition: true,
                activity: 2,
                data: [],
                settings: { types: [], markets: [], groups: [], followers: false, folowing: false }
            },
            TradingDiary: { id: 3, name: "Trading Diary", component: "TradingDiary", activity: 5, data: [], settings: {} },
            TradePreparation: {
                id: 4,
                name: "Trade Preparation",
                component: "TradePreparation",
                activity: 0,
                data: {},
                settings: {},
                statistics: { PL: 0 }
            },
            CurrentPreparation: { data: {} },

            ClosedTrades: { id: 5, name: "Live Trades", component: "ClosedTrades", transition: true, activity: 0, data: [], settings: {}, statistics: { PL: 0 } },
            OpenTrades: { id: 7, name: "Open Trades", component: "OpenTrades", transition: true, activity: 0, data: [], settings: {}, statistics: { PL: 0 } },
            DailyResults: { id: 6, name: "Daily Results", component: "DailyResults", transition: true, activity: 0, data: [], settings: {}, statistics: { PL: 0 } },

            // STORE COMPONENTS MODELS:
            Tags: { data: [] },
            TagDetail: { data: { _images: [], _log: [] } },
            Strategies: { data: [] },
            StrategyDetail: { data: { _images: [], _log: [], _checkList: [], name: null } },
            Users: { data: [] },
            UserDetail: { data: [] },

            PreparationInputs: {
                markets: { data: [], selected: null },
                price: { data: [], selected: null },
                strategies: { data: [], selected: null },
                type: { data: ["Long", "Short"], selected: null },
                tags: { data: [], selected: null },
                checklist: { data: [], selected: null },
                tif: { data: ["End of Day", "1 Hour", "15 Minutes", "5 Minutes", "Till Cancel"], selected: null }
            }

        },

        minicharts: [
            { component: "MiniEquity", name: "Equity" },
            { component: "MiniGauge", name: "Success Rate" },
            { component: "MiniMarkets", name: "Markets" },
            { component: "MiniWeek", name: "Week Days" },
            { component: "MiniSeven", name: "Last 7 active days" }
        ]
    },
    // SETTERS:
    mutations: {
        errors: (state, data) => {
            state.errors[data.target] = data.status;
        },

        retrieveToken(state, data) {
            state.userData = data.user
            state.userLoaded = true
        },

        destroyUser(state) {
            state.userData = { token: null, username: "Visitor" }
            state.userLoaded = false
        },
        updateUserdata(state, data) {
            if (data.name == "birth")
                state.userData.birth = data.value
            else if (data.name == "gender")
                state.userData.gender = data.value
            else
                state.userData[data.name] = data.value
        },
        setUserdata(state, user) {
            state.userData = user
            state.userLoaded = true
        },
        updateApi(state, data) {
            state.userData.platforms.sierrachart.apikey = data.api
        },
        updatePlatform(state, data) {
            state.userData.platforms.sierrachart.accountname = data.accountname
        },
        removePlatform(state) {
            state.userData.platforms.sierrachart.accountname = null
        },
        addStrategy(state, data) {
            state.userData.evaluation.strategies.unshift(data)
        },
        socketUpdateItem(state, socket) {
            state.componentMap[socket.component].transition = true
            if (state.componentMap[socket.component].data.length > 9)
                state.componentMap[socket.component].data.pop()
            state.componentMap[socket.component].data.forEach((item, index) => {
                if (item.Timestamp == socket.data.Timestamp) {
                    //setTimeout(() => {
                    if (socket.component == "PoolTimeline") {
                        Vue.set(state.componentMap[socket.component].data, index, socket.data)
                    }
                    if (socket.component == "OpenTrades") {
                        Vue.set(state.componentMap[socket.component].data, index, socket.data)
                        var actualData = state.componentMap[socket.component].data
                        var stat = { PL: 0, DailyQuantity: 0, TradesCount: 0 }

                        actualData.forEach(function(itm) {
                            stat.PL += itm.Data.OpenProfitLoss
                            stat.DailyQuantity += Math.abs(itm.Data.Quantity)
                            stat.TradesCount++
                        })

                        state.componentMap[socket.component].statistics = stat
                    }
                    //}, 100);
                }
            })


        },

        ADD_SOCKET(state, socket) {
            state.componentMap[socket.component].transition = true
            if (state.componentMap[socket.component].data.length > 9) {
                state.componentMap[socket.component].data.pop()
            }
            // ADD TO STATE
            state.componentMap[socket.component].data.unshift(socket.data)
                // CALCULATE DAILY STATS (IF NEEDED)
            if (socket.component == "ClosedTrades") {
                state.componentMap[socket.component].statistics.PL += socket.data.Data.ClosedProfitLoss
                state.componentMap[socket.component].statistics.DailyQuantity += socket.data.Data.EntryQuantity
                state.componentMap[socket.component].statistics.TradesCount++
            }
            if (socket.component == "OpenTrades") {
                var actualData = state.componentMap[socket.component].data
                var stat = { PL: 0, DailyQuantity: 0, TradesCount: 0 }

                actualData.forEach(function(itm) {

                    stat.PL += itm.Data.OpenProfitLoss
                    stat.DailyQuantity += Math.abs(itm.Data.Quantity)
                    stat.TradesCount++
                })
                state.componentMap[socket.component].statistics = stat
            }

            // INCREMENT COMPONENT ACTIVITY
            state.componentMap[socket.component].data.activity++
        },

        UPDATE_SOCKET(state, socket) {
            state.componentMap[socket.component].data.forEach((item, index) => {
                if (item._id == socket.data._id) {
                    //
                    //Vue.delete(state.componentMap[socket.component].data, index)
                    Vue.set(state.componentMap[socket.component].data, index, socket.data)

                }
            })
            setTimeout(() => {
                //state.componentMap[socket.component].data.unshift(socket.data)
            }, 100);
            //
        },





        ADD_COMPONENT_DATA(state, data) {
            state.componentMap[data.component].transition = true
            if (state.componentMap[data.component].data.length > 9) {
                state.componentMap[data.component].data.pop()
            }
            // ADD TO STATE
            state.componentMap[data.component].data.unshift(data.data)
                // CALCULATE DAILY STATS (IF NEEDED)
            if (data.component == "ClosedTrades") {
                state.componentMap[data.component].statistics.PL += data.data.Data.ClosedProfitLoss
                state.componentMap[data.component].statistics.DailyQuantity += data.data.Data.EntryQuantity
                state.componentMap[data.component].statistics.TradesCount++
            }
            if (data.component == "OpenTrades") {
                var actualData = state.componentMap[data.component].data
                var stat = { PL: 0, DailyQuantity: 0, TradesCount: 0 }

                actualData.forEach(function(itm) {

                    stat.PL += itm.Data.OpenProfitLoss
                    stat.DailyQuantity += Math.abs(itm.Data.Quantity)
                    stat.TradesCount++
                })
                state.componentMap[data.component].statistics = stat
            }

            // INCREMENT COMPONENT ACTIVITY
            state.componentMap[data.component].data.activity++
        },

        SET_COMPONENT_DATA(state, data) {
            state.componentMap[data.component].data = data.data
        },


        REMOVE_COMPONENT_DATA(state, data) {
            state.componentMap[data.component].data.forEach((item, index) => {
                if (item._id === data.data) {
                    Vue.delete(state.componentMap[data.component].data, index)
                    return false;
                }
            })
        },

        UPDATE_COMPONENT_DATA(state, data) {
            state.componentMap[data.component].transition = true
            if (state.componentMap[data.component].data.length > 9)
                state.componentMap[data.component].data.pop()
            state.componentMap[data.component].data.forEach((item, index) => {

                if (item._id == data.data._id) {

                    if (data.component == "OpenTrades") {
                        Vue.set(state.componentMap[data.component].data, index, data.data)
                        var actualData = state.componentMap[data.component].data
                        var stat = { PL: 0, DailyQuantity: 0, TradesCount: 0 }

                        actualData.forEach(function(itm) {
                            stat.PL += itm.Data.OpenProfitLoss
                            stat.DailyQuantity += Math.abs(itm.Data.Quantity)
                            stat.TradesCount++
                        })

                        state.componentMap[data.component].statistics = stat
                    } else {
                        Vue.set(state.componentMap[data.component].data, index, data.data)
                    }
                }
            })
        },




        socketAddItem(state, socket) {
            state.componentMap[socket.component].transition = true
            if (state.componentMap[socket.component].data.length > 9) {
                state.componentMap[socket.component].data.pop()
            }

            // ADD TO STATE
            state.componentMap[socket.component].data.unshift(socket.data)

            // CALCULATE DAILY STATS (IF NEEDED)
            if (socket.component == "ClosedTrades") {
                state.componentMap[socket.component].statistics.PL += socket.data.Data.ClosedProfitLoss
                state.componentMap[socket.component].statistics.DailyQuantity += socket.data.Data.EntryQuantity
                state.componentMap[socket.component].statistics.TradesCount++
            }
            if (socket.component == "OpenTrades") {
                var actualData = state.componentMap[socket.component].data
                var stat = { PL: 0, DailyQuantity: 0, TradesCount: 0 }

                actualData.forEach(function(itm) {

                    stat.PL += itm.Data.OpenProfitLoss
                    stat.DailyQuantity += Math.abs(itm.Data.Quantity)
                    stat.TradesCount++
                })
                state.componentMap[socket.component].statistics = stat
            }

            // INCREMENT COMPONENT ACTIVITY
            state.componentMap[socket.component].data.activity++
        },


        socketRemoveItem(state, socket) {
            state.componentMap[socket.component].transition = true
            state.componentMap[socket.component].data.forEach((item, index) => {
                if (item.Timestamp == socket.data.Timestamp) {
                    setTimeout(() => {
                        //state.componentMap[socket.component].transition = true
                        Vue.delete(state.componentMap[socket.component].data, index)
                        var actualData = state.componentMap[socket.component].data
                        var stat = { PL: 0, DailyQuantity: 0, TradesCount: 0 }
                            //state.componentMap[socket.component].transition = true
                        actualData.forEach(function(itm) {

                            stat.PL += itm.Data.OpenProfitLoss
                            stat.DailyQuantity += Math.abs(itm.Data.Quantity)
                            stat.TradesCount++
                        })
                        state.componentMap[socket.component].statistics = stat
                    }, 100);
                }
            })
        },



        setComponentData(state, data) {
            state.componentMap[data.component].data = data.data
        },



        updateSubmenu(state, data) {
            state.userData.settings.submenus[data.section].selected = data.value
        },

        updatePresets(state, data) {
            if (state.userData.settings.hasOwnProperty('presets')) {
                state.userData.settings.presets[data.section] = data.value
            } else {
                state.userData.settings.presets = {}
                state.userData.settings.presets[data.section] = data.value
            }
        },

        resetActivity(state, data) {
            var activeComponentIndex = state.userData.settings.submenus[data.section].selected
            setTimeout(() => {
                state.userData.settings.submenus[data.section].items[activeComponentIndex].activity = 0
            }, 2000);
        },
        statsCalc(state, data) {
            var actualData = state.componentMap[data.component].data
            var stat = { PL: 0, DailyQuantity: 0, TradesCount: 0 }

            actualData.forEach(function(itm) {
                if (data.component == "ClosedTrades") {
                    stat.PL += itm.Data.ClosedProfitLoss
                    stat.DailyQuantity += itm.Data.EntryQuantity
                    stat.TradesCount++
                }
                if (data.component == "OpenTrades") {
                    stat.PL += itm.Data.OpenProfitLoss
                    stat.DailyQuantity += Math.abs(itm.Data.Quantity)
                    stat.TradesCount++
                }

            });
            state.componentMap[data.component].statistics = stat
        },




        API_UPDATE(state, api) {

            state.componentMap[api.data.component].data.forEach(item => {

                if (item._id == api.data.id) {

                    if (api.data.hasOwnProperty("set")) {
                        if (api.data.setPartial) {
                            api.data.set.forEach(setData => {
                                item[setData.key] = setData.value
                            })
                        } else {
                            item = api.data.set
                        }
                    }

                    if (api.data.hasOwnProperty("push")) {
                        api.data.push.forEach(pushData => {
                            item[pushData.key].unshift(pushData.value)
                        })
                    }

                    if (api.data.hasOwnProperty("remove")) {
                        api.data.remove.forEach(removeData => {

                            item[removeData.key].forEach((images, index) => {
                                if (images._id == removeData.value) {
                                    item[removeData.key].splice(index, 1)
                                }
                            })

                        })
                    }


                }

            })
        },


        API_REQUEST(state, api) {
            var component
            if (api.data.hasOwnProperty("setWhole")) {
                component = api.data.component
                    //alert(api.data.setWhole.tags.data)
                state.componentMap[component] = api.data.setWhole
                    //Vue.set(state.componentMap[api.data.component], api.data.setWhole)
            } else {
                component = api.component
                state.componentMap[component].data = api.data

                // update activity chip
                state.userData.settings.submenus.Section2.items.forEach(comp => {
                    if (comp.component == component)
                        comp.activity = api.data.length
                })

            }
            var actualData = state.componentMap[api.component].data
            var stat = { PL: 0, DailyQuantity: 0, TradesCount: 0 }
            if (api.component == "ClosedTrades") {


                actualData.forEach(function(itm) {
                    stat.PL += itm.ClosedProfitLoss
                    stat.DailyQuantity += Math.abs(itm.MaxOpenQuantity)
                    stat.TradesCount++
                })

                state.componentMap[api.component].statistics = stat
            }
            if (api.component == "DailyResults") {

                actualData.forEach(function(itm) {
                    stat.PL += itm.pl
                    stat.DailyQuantity += Math.abs(itm.lots)
                    stat.TradesCount += itm.trades
                })

                state.componentMap[api.component].statistics = stat
            }
        },


        API_UPDATE_SETTINGS(state, api) {
            if (api.set.key == "submenus.Section0.items") {
                state.userData.settings.submenus.Section0.items = api.set.value
            } else
            //Vue.set(state.userData.settings[api.set.key], api.set.value)
                state.userData.settings[api.set.key] = api.set.value
        },




        CLEAR(state, data) {
            state.componentMap[data].data = { _images: [], _log: [], _checkList: [] }
        },




        SCK_ADD_DATA(state, data) {
            //alert(data.component)
            //state.componentMap[data.component].transition = true
            //if (state.componentMap[data.component].data.length > 9)
            //    state.componentMap[data.component].data.pop()
            var component = data.component
            if (state.componentMap[component].data.length > 9) {
                state.componentMap[component].data.pop()
            }

            state.componentMap[component].data.unshift(data)
                // update activity chip
            state.userData.settings.submenus.Section2.items.forEach(comp => {
                if (comp.component == component)
                    comp.activity++
            })

        },


        SCK_REMOVE_DATA(state, data) {
            state.componentMap[data.component].data.forEach((item, index) => {
                if (item.openTimestamp == data.openTimestamp) {
                    data.active = false
                    Vue.set(state.componentMap[data.component].data, index, data)
                }
            })
            var component = data.component
            state.userData.settings.submenus.Section2.items.forEach(comp => {
                if (comp.component == component)
                    comp.activity--
            })
            setTimeout(() => {
                state.componentMap[component].data.forEach((item, index) => {
                        if (item.openTimestamp == data.openTimestamp) {
                            Vue.delete(state.componentMap[component].data, index)
                        }
                    })
                    // update activity chip

                // reset stat if no data
                if (state.componentMap[component].data.length == 0) {
                    var stat = { PL: 0, DailyQuantity: 0, TradesCount: 0 }
                    state.componentMap[component].statistics = stat
                }
            }, 10000);
        },

        SCK_UPDATE_DATA(state, data) {
            state.componentMap[data.component].data.forEach((item, index) => {
                if (data.component != "DailyResults") {
                    if (item.openTimestamp == data.openTimestamp) {
                        Vue.set(state.componentMap[data.component].data, index, data)
                    }
                } else {
                    if (item._id == data._id) {
                        data._user = item._user
                        Vue.set(state.componentMap[data.component].data, index, data)
                    }
                }
            })
            var actualData = state.componentMap[data.component].data
            var stat = { PL: 0, DailyQuantity: 0, TradesCount: 0 }
            if (data.component == "DailyResults") {

                actualData.forEach(function(itm) {
                    stat.PL += itm.pl
                    stat.DailyQuantity += Math.abs(itm.lots)
                    stat.TradesCount += itm.trades
                })

                state.componentMap[data.component].statistics = stat
            }
            if (data.component == "OpenTrades") {

                actualData.forEach(function(itm) {
                    stat.PL += itm.OpenProfitLoss
                    stat.DailyQuantity += Math.abs(itm.Quantity)
                    stat.TradesCount++
                })

                state.componentMap[data.component].statistics = stat
            }
        },

        SCK_MARKET(state, data) {
            state.test = data
        },



    },
    actions: {
        SOCKET_CLOSE_TRADE() {
            playAlert("close")
        },
        SOCKET_NEW_TRADE() {
            playAlert("open")
        },
        SOCKET_TWEETS() {
            //playAlert("tweet")
        },
        SOCKET_TIMELINE(context, data) {
            if (data.action == 'add' && data.type == "Trade Prepare") {
                playAlert("prepare")
            } else if (data.action == 'add' && data.type == "Message") {
                playAlert("chat")
            }
        },

        /*
        // RECEIVING SOCKETS

        SOCKET_NEW_TRADE(context, data) {
            //alert(data.component)
            context.commit('SCK_ADD_DATA', data)
            playAlert("open")
        },
        SOCKET_CLOSE_TRADE(context, data) {
            //alert(data.component)
            data.component = "OpenTrades"
            context.commit('SCK_REMOVE_DATA', data)
            data.component = null
            data.component = "ClosedTrades"
            context.commit('SCK_ADD_DATA', data)
            playAlert("close")
        },

        SOCKET_UPDATE_TRADE(context, data) {
            //alert(data.component)
            data.component = "OpenTrades"
            context.commit('SCK_UPDATE_DATA', data)
        },

        SOCKET_UPDATE_RESULT(context, data) {
            //alert(data.component)
            data.component = "DailyResults"
            context.commit('SCK_UPDATE_DATA', data)
        },


        SOCKET_NEWCHAT(context, data) {
            context.commit('socketAddItem', { component: "PoolTimeline", data: data })
            playAlert("open")
        },
        SOCKET_NEWPREPARE(context, data) {
            context.commit('socketAddItem', { component: "PoolTimeline", data: data })
        },
        SOCKET_UPDATEPREPARE(context, data) {
            context.commit('socketUpdateItem', { component: "PoolTimeline", data: data })
        },

        */

        /*
        SOCKET_NEWTRADE(context, data) {
            context.commit('socketAddItem', { component: "PoolTimeline", data: data })
            context.commit('socketAddItem', { component: "ClosedTrades", data: data })
                //context.commit('socketRemoveItem', { component: "OpenTrades", data: data })
            playAlert("close")
        },
        */

        /*
        SOCKET_OPENTRADE(context, data) {
            //context.commit('socketAddItem', { component: "PoolTimeline", data: data })
            context.commit('socketAddItem', { component: "OpenTrades", data: data })
            playAlert("open")
        },
        SOCKET_UPDATETRADE(context, data) {
            context.commit('socketUpdateItem', { component: "PoolTimeline", data: data })
            context.commit('socketUpdateItem', { component: "OpenTrades", data: data })
        },
        SOCKET_REMOVE(context, data) {
            context.commit('socketUpdateItem', { component: "PoolTimeline", data: data })
            context.commit('socketRemoveItem', { component: "OpenTrades", data: data })
        },

        */

        // RECEIVING DATA THROUGH API
        getComponentData(context, data) {
            axios.defaults.headers.common['Authorization'] = `Token ${localStorage.getItem('access_token')}`
            return new Promise((resolve, reject) => {
                axios.post("https://tradeinpool.com:3001/api/load/", { data })
                    .then(response => {
                        context.commit('setComponentData', { component: data.component, data: response.data })
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        getUserdata(context) {
            axios.defaults.headers.common['Authorization'] = `Token ${localStorage.getItem('access_token')}`
            return new Promise((resolve, reject) => {
                axios.post("https://tradeinpool.com:3001/api/users/current")
                    .then(response => {
                        localStorage.setItem('access_token', response.data.token)
                        context.commit('setUserdata', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        context.commit('destroyUser')
                        localStorage.removeItem('access_token')
                        delete axios.defaults.headers.common['Authorization']
                        reject(error)
                    })
            })
        },





        // SENDING DATA THROUGH API
        updateUserdata(context, data) {
            var suffix = data.type
            if (suffix == "submenu") {
                context.commit('updateSubmenuPosition', data)
            } else {
                context.commit('updateUserdata', data)
            }
            axios.post("https://tradeinpool.com:3001/api/update/" + suffix, {
                data
            })
        },





        // SENDING DATA THROUGH API
        API_COMPONENT_REQUESTS(context, data) {
            axios.defaults.headers.common['Authorization'] = `Token ${localStorage.getItem('access_token')}`
            return new Promise((resolve, reject) => {
                var requestUrl = "https://tradeinpool.com:3001/api/" + data.action + "/" + data.document
                axios.post(requestUrl, data)
                    .then(response => {
                        resolve(response)
                            // IF REQUEST INSERT DATA TO STORE
                        if (data.action == "request") {

                            context.commit('SET_COMPONENT_DATA', { component: data.component, data: response.data })

                        } else if (data.action == "add") {
                            context.commit('ADD_COMPONENT_DATA', { component: data.component, data: response.data })

                        } else if (data.action == "update") {
                            //context.commit('UPDATE_COMPONENT_DATA', { component: data.component, data: response.data })

                        } else if (data.action == "remove") {
                            context.commit('REMOVE_COMPONENT_DATA', { component: data.component, data: response.data })
                        } else if (data.action == "upload") {
                            //context.commit('REMOVE_COMPONENT_DATA', { component: data.component, data: response.data })
                        }


                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // SENDING DATA THROUGH API
        API_UPLOAD_REQUESTS(context, data) {
            axios.defaults.headers.common['Authorization'] = `Token ${localStorage.getItem('access_token')}`
            return new Promise((resolve, reject) => {
                var requestUrl = "https://tradeinpool.com:3001/api/upload/"

                axios.post(requestUrl, data)
                    .then(response => {
                        resolve(response)
                        response.component = "TagDetail"
                        context.commit("API_UPDATE", response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        API_REQUESTS(context, data) {
            axios.defaults.headers.common['Authorization'] = `Token ${localStorage.getItem('access_token')}`
            return new Promise((resolve, reject) => {
                var requestUrl = "https://tradeinpool.com:3001/api/" + data.action + "/" + data.document

                axios.post(requestUrl, data)
                    .then(response => {

                        resolve(response)

                        if (data.component == "user") { // user settings
                            context.commit("API_USER_" + data.action, response)

                        } else { // component data
                            response.component = data.component
                            context.commit("API_" + data.action, response)
                        }

                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },



        API_UPDATE_SETTINGS(context, data) {
            axios.defaults.headers.common['Authorization'] = `Token ${localStorage.getItem('access_token')}`
            return new Promise((resolve, reject) => {
                var requestUrl = "https://tradeinpool.com:3001/api/update/users/settings"
                axios.post(requestUrl, data)
                    .then(response => {
                        resolve(response)
                        context.commit('API_UPDATE_SETTINGS', response.data)

                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        CLEAR(context, data) {
            context.commit('CLEAR', data)
        },




        API_INIT(context, data) {
            axios.defaults.headers.common['Authorization'] = `Token ${localStorage.getItem('access_token')}`
            return new Promise((resolve, reject) => {
                var requestUrl = "https://tradeinpool.com:3001/api/" + data.action + "/" + data.document

                axios.post(requestUrl, data)
                    .then(response => {

                        context.commit("API_" + data.action, response)

                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        API_NEW(context, data) {
            axios.defaults.headers.common['Authorization'] = `Token ${localStorage.getItem('access_token')}`
            return new Promise((resolve, reject) => {
                var requestUrl = "https://tradeinpool.com:3001/api/" + data.action + "/" + data.document

                axios.post(requestUrl, data)
                    .then(response => {

                        context.commit("API_" + data.action, response)

                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        API_UPDATE(context, data) {
            axios.defaults.headers.common['Authorization'] = `Token ${localStorage.getItem('access_token')}`
            return new Promise((resolve, reject) => {
                var requestUrl = "https://tradeinpool.com:3001/api/" + data.action + "/" + data.document

                axios.post(requestUrl, data)
                    .then(response => {

                        context.commit("API_" + data.action, response)

                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        API_DELETE(context, data) {
            axios.defaults.headers.common['Authorization'] = `Token ${localStorage.getItem('access_token')}`
            return new Promise((resolve, reject) => {
                var requestUrl = "https://tradeinpool.com:3001/api/" + data.action + "/" + data.document

                axios.post(requestUrl, data)
                    .then(response => {

                        context.commit("API_" + data.action, response)

                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },


        // SENDING DATA THROUGH API
        API_USER_REQUESTS(context, data) {
            axios.defaults.headers.common['Authorization'] = `Token ${localStorage.getItem('access_token')}`
            return new Promise((resolve, reject) => {
                var requestUrl = "https://tradeinpool.com:3001/api/users/" + data.action
                axios.post(requestUrl, data)
                    .then(response => {

                        if (data.action == "current") {
                            localStorage.setItem('access_token', response.data.user.token)
                            context.commit('setUserdata', response.data.user)
                                //Vue.$socket.emit("auth", response.data.user.token)
                                //Vue.$socket.emit('auth', response.data.user.token)

                        } else if (data.action == "login") {
                            localStorage.setItem('access_token', response.data.user.token)
                            context.commit('retrieveToken', response.data)
                                //Vue.$socket.emit("auth", response.data.user.token)
                                //this.$socket.emit("auth", response.data.user.token)
                                //Vue.$socket.emit('auth', response.data.user.token)

                        } else if (data.action == "update") {
                            context.commit('updateUserdata', data)
                        }

                        context.commit('updateUserdata', data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },






        INTERNAL_STATE_UPDATE(context, data) {
            context.commit('updateUserdata', data)
        },

        // SENDING DATA THROUGH API
        updateUsername(context, data) {
            return new Promise((resolve, reject) => {
                axios.post("https://tradeinpool.com:3001/api/update/username", {
                        data
                    })
                    .then(response => {
                        resolve(response)
                        context.commit('updateUserdata', data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        updateApi(context, data) {
            return new Promise((resolve, reject) => {
                axios.post("https://tradeinpool.com:3001/api/update/api", {
                        data
                    })
                    .then(response => {
                        resolve(response)
                        context.commit('updateApi', response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        updatePlatformAccount(context, data) {
            return new Promise((resolve, reject) => {
                axios.post("https://tradeinpool.com:3001/api/update/platform", {
                        data
                    })
                    .then(response => {
                        if (response.data.update == true) {
                            resolve(response)
                            context.commit('updatePlatform', response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        addPrepare(context, data) {
            return new Promise((resolve, reject) => {
                axios.post("https://tradeinpool.com:3001/api/prepare/add", {
                        data
                    })
                    .then(response => {
                        if (response.data.update == true) {
                            resolve(response)
                        } else {
                            reject(response)
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
                    //  })
            })
        },

        addStrategy(context, data) {
            return new Promise((resolve, reject) => {
                axios.post("https://tradeinpool.com:3001/api/strategy/add", {
                        data
                    })
                    .then(response => {
                        if (response.data.update == true) {
                            resolve(response)
                            context.commit('addStrategy', response.data.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
                    //  })
            })
        },

        removePlatformAccount(context, data) {
            return new Promise((resolve, reject) => {
                axios.post("https://tradeinpool.com:3001/api/update/platform", {
                        data
                    })
                    .then(response => {
                        if (response.data.update == true) {
                            resolve(response)
                            context.commit('updatePlatform', response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // SENDING DATA THROUGH API
        updatePassword(context, data) {
            return new Promise((resolve, reject) => {
                axios.post("https://tradeinpool.com:3000/api/update/password", {
                        user: {
                            email: data.email,
                            password: data.password,
                        },
                        newpassword: data.newpassword
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // SENDING DATA THROUGH API
        recoverPassword(context, data) {
            return new Promise((resolve, reject) => {
                axios.post("https://tradeinpool.com:3001/api/update/lostpassword", {
                        user: {
                            token: data.token,
                            password: data.password,
                        },
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        updateSubmenu(context, data) {
            context.commit('updateSubmenu', data)
                //context.commit('resetActivity', data)
            axios.post("https://tradeinpool.com:3001/api/update/submenu", {
                data
            })

        },



        updateSubmenuTest(context, data) {
            context.commit('updateSubmenu', data)
            axios.post("https://tradeinpool.com:3001/api/update/submenutest", {
                data
            })
        },

        updateUserPreset(context, data) {
            context.commit('updatePresets', data)
            axios.post("https://tradeinpool.com:3001/api/update/userpresets", {
                data
            }).then(() => {

            })

        },


        addChat(getters, data) {
            //addHeader()
            axios.defaults.headers.common['Authorization'] = `Token ${localStorage.getItem('access_token')}`
            return new Promise((resolve, reject) => {
                axios.post("https://tradeinpool.com:3001/api/timeline/chat/", {
                        text: data.text,
                        username: this.getters.username
                    })
                    .then(response => {
                        //context.commit('apiClosedTrades', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // USER HANDLING
        register(context, data) {
            return new Promise((resolve, reject) => {
                axios.post("https://tradeinpool.com:3001/api/users/register", {
                        user: data
                    })
                    .then(response => {
                        localStorage.setItem('access_token', response.data.user.token)
                        context.commit('retrieveToken', response.data)
                        axios.defaults.headers.common['Authorization'] = `Token ${response.data.user.token}`
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        destroyToken(context) {
            localStorage.removeItem('access_token')
            context.commit('destroyUser')
            delete axios.defaults.headers.common['Authorization']
        },

        retrieveToken(context, credentials) {
            return new Promise((resolve, reject) => {
                axios.post("https://tradeinpool.com:3001/api/users/login", {
                        user: {
                            email: credentials.email,
                            password: credentials.password
                        }
                    })
                    .then(response => {
                        localStorage.setItem('access_token', response.data.user.token)
                        context.commit('retrieveToken', response.data)
                        axios.defaults.headers.common['Authorization'] = `Token ${response.data.user.token}`
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        passwordRecovery(context, credentials) {
            return new Promise((resolve, reject) => {
                axios.post("https://tradeinpool.com:3001/api/users/recovery", {
                        user: {
                            email: credentials.email,
                        }
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        resetActivity(context, data) {
            context.commit('resetActivity', data)
        },
        statsCalc(context, data) {
            context.commit('statsCalc', data)
        }
    },
    getters: {

        notifications(state) {
            return state.userData.notifications
        },
        settings(state) {
            return state.userData.settings
        },

        markets(state) {
            return state.userData.markets
        },

        loggedIn(state) {
            return state.userData.token !== null
        },
        userLoaded(state) {
            return state.userLoaded
        },
        username(state) {
            return state.userData.username
        },
        apiSierraChart(state) {
            return state.userData.platforms.sierrachart.apikey
        },
        accountSierraChart(state) {

            return state.userData.platforms.sierrachart.accountname
        },
        userToken(state) {
            return state.userData.token
        },
        avatar(state) {
            return state.userData.avatar
        },

        birth(state) {
            if (state.userData.hasOwnProperty('birth'))
                return state.userData.birth
            else return null
        },
        gender(state) {
            if (state.userData.hasOwnProperty('gender'))
                return state.userData.gender
            else return null
        },

        usermail(state) {
            return state.userData.email
        },
        userSettings(state) {
            return state.userData.settings
        },
        userSubmenus(state) {
            return state.userData.settings.submenus
        },
        chartSubmenus(state) {
            return state.userData.settings.submenus.Section0.items
        },
        timezone(state) {
            return state.userData.timezone
        },
        PoolTimelineData(state) {
            return state.componentMap.PoolTimeline.data
        },
        PoolTimelineTrans(state) {
            return state.componentMap.PoolTimeline.transition
        },
        TradePreparationData(state) {
            return state.componentMap.TradePreparation.data
        },


        ClosedTradesData(state) {
            return state.componentMap.ClosedTrades.data
        },
        ClosedTradesStatistics(state) {
            return state.componentMap.ClosedTrades.statistics
        },


        OpenTradesData(state) {
            return state.componentMap.OpenTrades.data
        },
        OpenTradesStatistics(state) {
            return state.componentMap.OpenTrades.statistics
        },


        DailyResultsData(state) {
            return state.componentMap.DailyResults.data
        },
        DailyResultsStatistics(state) {
            return state.componentMap.DailyResults.statistics
        },


        apiServer(state) {
            return state.apiServer
        },
        Strategies(state) {
            return state.componentMap.Strategies.data
        },
        Tags(state) {
            return state.componentMap.Tags.data
        },
        UserTiF(state) {
            return state.userData.timeInForce
        },



        TagDetail(state) {
            if (state.componentMap.TagDetail.data.length)
                return state.componentMap.TagDetail.data[0]
            else return null
        },
        TagDetailLog(state) {
            if (state.componentMap.TagDetail.data.length)
                return state.componentMap.TagDetail.data[0]._log
            else return null
        },
        TagDetailImages(state) {
            if (state.componentMap.TagDetail.data.length)
                return state.componentMap.TagDetail.data[0]._images
            else return null
        },
        TagDetailMinicharts(state) {
            return state.userData.settings.minichartsTag
        },






        StrategyDetail(state) {
            if (state.componentMap.StrategyDetail.data.length)
                return state.componentMap.StrategyDetail.data[0]
            else return null
        },
        StrategyDetailLog(state) {
            if (state.componentMap.StrategyDetail.data.length)
                return state.componentMap.StrategyDetail.data[0]._log
            else return null
        },
        StrategyDetailImages(state) {
            if (state.componentMap.StrategyDetail.data.length)
                return state.componentMap.StrategyDetail.data[0]._images
            else return null
        },
        StrategyDetailMinicharts(state) {
            return state.userData.settings.minichartsStrategy
        },






        Minicharts(state) {
            return state.minicharts
        },


        PreparationInputs(state) {
            return state.componentMap.PreparationInputs
        },

        CurrentPreparation(state) {
            return state.componentMap.CurrentPreparation
        },

    },

})

export default store


export function playAlert(type) {
    var audio
    if (type == "open") {
        audio = new Audio('https://tradeinpool.com/sounds/trade-open.mp3');
    } else if (type == "close")
        audio = new Audio('https://tradeinpool.com/sounds/trade-close.mp3');
    else if (type == "prepare")
        audio = new Audio('https://tradeinpool.com/sounds/open-up.mp3');
    else if (type == "chat")
        audio = new Audio('https://tradeinpool.com/sounds/light.mp3');
    else if (type == "tweet")
        audio = new Audio('https://tradeinpool.com/sounds/twtr.m4a');
    audio.play();

}